import { useEffect, useState } from "react";
import general from "../../../general";
import { useReactive } from "ahooks";
import { Link } from "react-router-dom";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useUrlState from "@ahooksjs/use-url-state";

// 游戏交易列表
export default () => {
  const [query] = useUrlState({});

  const data = useReactive({
    loading: false,
  });

  const [trades, setTrades] = useState([]);
  const [init, setInit] = useState(false);
  const load = () => {
    if (data.loading) {
      return;
    }
    data.loading = true;
    Dialog.loading();
    general.axios
      .post("/v3/user/trade/getTradeList", {
        apply_type: 1,
        sort_type: "xh_login_time",
        game_id: query.game_id,
        pagination: { count: 100, page: 1 },
      })
      .finally(() => {
        setInit(true);
        data.loading = false;
        Dialog.close();
      })
      .then((res) => {
        let result = res.data.data;
        setTrades(result.account_list);
      })
      .catch((err) => {
        Dialog.error("getTradeList " + err.message);
      });
  };
  useEffect(() => {
    load();
  }, []);

  return (
    <div className="game-trade">
      {trades.length > 0 &&
        trades.map((trade) => (
          <Link
            key={trade.trade_id}
            to={"/trade/detail?id=" + trade.trade_id}
            className="trade-list-global"
          >
            <div className="trade-global-info">
              <div className="trade-global-info-left">
                <div className="trade-left-name">
                  {trade.game_name_main}
                  {trade.game_name_branch && (
                    <div className="trade-left-name-branch">
                      {trade.game_name_branch}
                    </div>
                  )}
                </div>
                <p className="trade-left-title">{trade.title}</p>
                <div className="trade-left-info">
                  <span className="server-name">区服：{trade.server_name}</span>
                  <span>实际充值：{trade.total_amount}元</span>
                </div>
              </div>
              <div className="trade-global-info-right">
                ¥{trade.trade_price}
              </div>
            </div>

            <div className="trade-global-info-pics">
              {trade?.pic_list?.slice(0, 3).map((item, index) => (
                <object key={index}>
                  <Link
                    to={
                      "/img?imgs=" +
                      trade?.pic_list +
                      "&img=" +
                      index +
                      "&tradeId=" +
                      trade.trade_id
                    }
                    className="bannerImg"
                  >
                    <Image src={item} alt="" />
                  </Link>
                </object>
              ))}
            </div>
          </Link>
        ))}

      {init && trades.length === 0 && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "30px",
          }}
        >
          <img style={{ width: "60%" }} src="/resources/empty.png" alt="" />
          <p>该游戏暂无交易哦</p>
        </div>
      )}
    </div>
  );
};
